<template>
  <div id="GPOverrideQuestion">
    <div
      v-if="question.top_icon"
      :style="{ color: question.top_icon.color }"
      class="top-icon-container"
    >
      <i
        class="fa"
        :class="[question.top_icon.icon, `fa-${question.top_icon.size}`]"
        aria-hidden="true"
      ></i>
    </div>
    <p
      v-if="question.sub_heading"
      v-html="question.sub_heading"
      class="paragraph"
    ></p>
    <div class="info-box">
      <div
        v-if="question.info_text_html"
        v-html="decodeData(question.info_text_html)"
        class="info-box-inner"
      ></div>
    </div>
    <p
      v-if="question.sub_text_html"
      v-html="decodeData(question.sub_text_html)"
      class="paragraph"
    ></p>
    <button
      v-if="question.override_button"
      @click="handleClick"
      class="btn-override"
    >
      {{ question.override_button }}
      <i class="fa fa-chevron-right" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "GPOverrideQuestion",
  props: ["answer", "question", "setAnswer"],
  data() {
    return {
      defaultAnswer: "gp_override_false",
      overrideAnswer: "gp_override_true"
    };
  },
  mounted() {
    this.setAnswer(this.defaultAnswer);
  },
  methods: {
    decodeData(data) {
      try {
        return atob(data);
      } catch (error) {
        return data;
      }
    },
    handleClick() {
      this.setAnswer(this.overrideAnswer);
      this.$emit("overrideAnswer");
    }
  }
};
</script>

<style lang="less">
#GPOverrideQuestion {
  .top-icon-container {
    display: flex;
    width: 120px;
    height: 120px;
    justify-content: center;
    align-items: center;
    margin: 0 auto 32px;

    .fa {
      font-size: 12rem;
    }
  }

  .paragraph {
    font-family: var(--font-regular, "DMSans");
    color: #1e1e22;
    text-align: center;
    font-size: 1.6rem;
    padding: 0;
    margin: 0 0 32px;
  }

  .info-box {
    background-color: rgba(231, 237, 255, 0.5);
    padding: 24px;
    border-radius: 20px;
    margin-bottom: 32px;

    h3,
    .fa {
      color: #403d56;
    }

    h3 {
      font-size: 1.6rem;
      line-height: 2rem;
      letter-spacing: normal;
      font-family: var(--font-bold, "DMSans Bold");
      padding: 0;
      margin: 0;
    }

    p {
      font-size: 1.6rem;
      color: #1e1e22;
      line-height: 2.4rem;
      letter-spacing: normal;
      font-family: var(--font-regular, "DMSans");
      padding: 0;
      margin: 0;
    }
  }
  .info-box-inner {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .btn-override {
    display: block;
    background-color: rgba(30, 30, 34, 0.05);
    border: 0;
    letter-spacing: normal;
    border-radius: 5px;
    padding: 16px 24px;
    color: #1e1e22;
    font-size: 1.4rem;
    font-family: var(--font-bold, "DMSans Bold");
    width: fit-content;
    margin: 0 auto;

    .fa {
      margin-left: 8px;
    }
  }
}
</style>
